import { render } from "./VerifyPage.vue?vue&type=template&id=3e0a6f00&scoped=true"
import script from "./VerifyPage.vue?vue&type=script&lang=js"
export * from "./VerifyPage.vue?vue&type=script&lang=js"

import "./VerifyPage.vue?vue&type=style&index=0&id=3e0a6f00&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0a6f00"]])

export default __exports__